import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  FaCheckCircle as CheckIcon,
  FaTimesCircle as TimesIcon,
} from 'react-icons/fa';

const HeartbeatStatusCellRenderer = ({ value }) => {
  if (value === null) {
    return null;
  }

  const heartbeatClassNames = classnames('connection-run-status-icon', {
    'text-danger': value === 0,
    'text-success': value === 1,
  });

  switch (value) {
    case 0: return <TimesIcon size={15} className={heartbeatClassNames} />;
    case 1: return <CheckIcon size={15} className={heartbeatClassNames} />;
    default: return null;
  }
};
HeartbeatStatusCellRenderer.propTypes = {
  value: PropTypes.number,
};

export default HeartbeatStatusCellRenderer;
